import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { providePrimeNG } from 'primeng/config';
import { provideHttpClient, withXhr } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { routes } from './app.routes';
import { TokenInterceptor } from './core/auth/token.interceptor';

import { environment } from '../environments/environment';
import { ActionsService } from './services/actions.service';


export function HttpLoaderFactory(http: HttpClient): TranslateLoader {
  return new (TranslateHttpLoader as any)(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withXhr()),
    providePrimeNG({ license: environment.primeLicense }),
    // the cdk overlay uses the browser top layer (popover) by default, which hides the PrimeNG overlays opened inside Material dialogs
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    ActionsService,
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'nl',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ]
};